import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = {
    refreshInterval: Number,
  };

  connect() {
    if (this.hasRefreshIntervalValue) {
      this.startRefreshing();
    }
  }

  disconnect() {
    this.stopRefreshing();
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.errorMessage();
      this.stopRefreshing();
    }, this.refreshIntervalValue);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  errorMessage() {
    $("#error-message-text").html(
      '<span class="icon-alert">注意</span>認証コードが無効となりました。再度認証方法を選択して操作を行ってください。',
    );
    $("#error-message").fadeIn();
    $("#account-code-button").css("pointer-events", "none");
  }
}
